import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons'
import { useFullscreen } from 'ahooks'

import { pick } from '../../../../utils/object'
import { useRemoteTableStore } from '../../Store/hooks/useStore'
import { Action } from '../Action'

export const Fullscreen = () => {
  const { containerRef } = useRemoteTableStore(state =>
    pick(state, ['containerRef'])
  )

  const [isFullscreen, { toggleFullscreen }] = useFullscreen(containerRef)

  return (
    <Action
      title={isFullscreen ? '退出全屏' : '全屏'}
      onClick={toggleFullscreen}
    >
      {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
    </Action>
  )
}
